// extracted by mini-css-extract-plugin
export default {"title":"title_title__m9TVd"};